<template>
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.75 2.5H11.25C5 2.5 2.5 5 2.5 11.25V18.75C2.5 25 5 27.5 11.25 27.5H18.75C25 27.5 27.5 25 27.5 18.75V16.25" stroke="#2C2738" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M20.0498 3.77507L10.1998 13.6251C9.82485 14.0001 9.44985 14.7376 9.37485 15.2751L8.83735 19.0376C8.63735 20.4001 9.59985 21.3501 10.9623 21.1626L14.7248 20.6251C15.2498 20.5501 15.9873 20.1751 16.3748 19.8001L26.2248 9.95007C27.9248 8.25007 28.7248 6.27507 26.2248 3.77507C23.7248 1.27507 21.7498 2.07507 20.0498 3.77507Z" stroke="#2C2738" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M18.6377 5.1875C19.4752 8.175 21.8127 10.5125 24.8127 11.3625" stroke="#2C2738" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
import iconMixin from "@/services/iconMixins.js";

export default {
  mixins: [iconMixin]
};
</script>
